<!--
 - User popover component HTML
 -
 - @version
 - 4.71.0 OAUI-694 Final UI tweaks and finishing touches
 -
 - @author Ryan Sweeney <rsweeney@buildcentrix.com>
 - @copyright (c) 2024 Build Centrix
 -->
<div class="text-center">
  <div>{{user.name?.first}} {{user.name?.last}}</div>
  <div>{{user.company?.label}}</div>
</div>
